// import React, { useState, useEffect, useRef } from 'react';
// import { Link } from 'react-router-dom';
// import './UserChatBox.css';
// import { FaArrowLeft, FaEllipsisV, FaUser } from 'react-icons/fa';
// import { DateRange } from "react-date-range";
// import "react-date-range/dist/styles.css";
// import "react-date-range/dist/theme/default.css";
// import bgimage from '../images/image-removebg-preview.png';
// import ExportConversationsmodal from './Export ConversationsModal';
// import WhatappchatforArchive from './whatappchatforArchive';
// import Whatapplivechat from './whatapplivechat';

// // --- Helper Functions for JWT decoding and User Id token extraction ---
// function decodeToken(token) {
//     if (!token) return {};
//     try {
//         const base64Url = token.split('.')[1];
//         const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//         const jsonPayload = decodeURIComponent(
//             atob(base64)
//                 .split('')
//                 .map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
//                 .join('')
//         );
//         return JSON.parse(jsonPayload);
//     } catch (e) {
//         return {};
//     }
// }

// function getUserIdAndToken() {
//     if (typeof window !== 'undefined') {
//         if (typeof window.locatorgarsotrga === 'function') {
//             const rawToken = window.locatorgarsotrga("token");
//             if (rawToken) {
//                 const decoded = decodeToken(rawToken);
//                 return {
//                     userId: decoded.id || decoded.userId || decoded._id,
//                     token: rawToken,
//                 };
//             }
//         }
//         const localToken = localStorage.getItem('token');
//         if (localToken) {
//             const decoded = decodeToken(localToken);
//             return {
//                 userId: decoded.id || decoded.userId || decoded._id,
//                 token: localToken,
//             };
//         }
//     }
//     return { userId: null, token: null };
// }

// // --- Main UserChatBox Component including LIVE WhatsApp chat structure ---
// const UserChatBox = () => {
//     // Drawer controls
//     const [showMenu, setShowMenu] = useState(false);
//     const menuRef = useRef(null);
//     const toggleMenu = () => setShowMenu(prev => !prev);

//     // Export Modal controls
//     const [Open, setOpen] = useState(false);
//     const [showPicker, setShowPicker] = useState(false);
//     const [state, setState] = useState([
//         {
//             startDate: new Date(),
//             endDate: new Date(),
//             key: "selection",
//         }
//     ]);
//     const [Daterange, setDaterange] = useState('');

//     // User and phone id
//     const { userId, token } = getUserIdAndToken();
//     const [phoneNumberId, setPhoneNumberId] = useState('');
//     useEffect(() => {
//         if (userId && token) {
//             fetch(`https://wa-api.globebot.io/auth/user/whatsapp-phone-numbers/${userId}`, {
//                 headers: { 'Authorization': `Bearer ${token}` }
//             })
//                 .then(r => r.json())
//                 .then(data => {
//                     if (Array.isArray(data) && data[0]?.phone_number_id) {
//                         setPhoneNumberId(data[0].phone_number_id);
//                     }
//                 })
//                 .catch(console.error);
//         }
//     }, [userId, token]);

//     // --- ARCHIVE MODE: Load old chat archive for WhatsApp contact list ---
//     const [messages, setMessages] = useState([]);
//     const [search, setSearch] = useState('');
//     const [selectedUser, setSelectedUser] = useState(null);

//     useEffect(() => {
//         if (phoneNumberId && token) {
//             fetch(`https://wa-api.globebot.io/auth/messages/?phone_number_id=${phoneNumberId}`, {
//                 headers: { 'Authorization': `Bearer ${token}` }
//             })
//                 .then(res => res.json())
//                 .then(data => setMessages(Array.isArray(data) ? data : []))
//                 .catch(console.error);
//         }
//     }, [phoneNumberId, token]);

//     // Grouping chat conversations by from_number (archive mode)
//     function groupConversations(messages) {
//         const grouped = {};
//         messages.forEach(msg => {
//             const key = msg.from_number;
//             if (!grouped[key]) {
//                 grouped[key] = {
//                     from_number: key,
//                     phone_number_id: msg.phone_number_id,
//                     messages: [],
//                     lastMessage: '',
//                     lastTime: '',
//                     unread: 0,
//                 };
//             }
//             grouped[key].messages.push(msg);

//             if (!grouped[key].lastTime || new Date(msg.created_at) > new Date(grouped[key].lastTime)) {
//                 grouped[key].lastMessage = msg.content;
//                 grouped[key].lastTime = msg.created_at;
//             }
//             if (msg.status === 'received') {
//                 grouped[key].unread += 1;
//             }
//         });
//         return Object.values(grouped);
//     }

//     const groupedChats = groupConversations(messages);
//     const filteredChats = groupedChats.filter(chat =>
//         (chat.from_number || "").toLowerCase().includes(search.toLowerCase())
//     );

//     function findUser(number) {
//         const userChat = groupedChats.find(item => item.from_number === number);
//         setSelectedUser(userChat || null);
//     }

//     // --- LIVE WhatsApp Chat Structure (STRUCTURE ONLY as requested) ---
//     const [liveActive, setLiveActive] = useState(false);
//     const [liveUser, setLiveUser] = useState(null);
//     const [liveMessages, setLiveMessages] = useState([]);
//     const [liveInput, setLiveInput] = useState('');
//     const [liveLoading, setLiveLoading] = useState(false);

//     // This is only the structure/scaffolding per request
//     // (Fetching live data is NOT active until integrated with your API endpoint in @authRoutes.ts (1592-1668))
//     const startLiveChat = (user) => {
//         setLiveActive(true);
//         setLiveUser(user);
//         setLiveMessages([]);
//         // ...add future live chat fetch here
//     };
//     const sendLiveMessage = async () => {
//         setLiveLoading(true);
//         // --- Structure: integrate with live send message API here ---
//         // Example:
//         // await fetch(LIVE_WHATSAPP_SEND_API_URL, { ... });
//         setLiveMessages(liveMessages => [
//             ...liveMessages,
//             { fromMe: true, content: liveInput, sentAt: new Date().toISOString() }
//         ]);
//         setLiveInput('');
//         setLiveLoading(false);
//     };

//     const closeLiveChat = () => {
//         setLiveActive(false);
//         setLiveUser(null);
//         setLiveMessages([]);
//         setLiveInput('');
//     };

//     // --- Color Pattern for Contacts ---
//     const colors = [
//         "bg-red-200",
//         "bg-green-200",
//         "bg-blue-200",
//         "bg-yellow-200",
//         "bg-purple-200",
//         "bg-pink-200",
//         "bg-indigo-200",
//     ];

//     function timeString(iso) {
//         if (!iso) return "";
//         const dt = new Date(iso);
//         return dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     }

//     return (
//         <>
//             <div className="flex min-h-screen bg-gray-100 pt-[100px] sm:pt-[50px]">
//                 {/* Sidebar: WhatsApp Chat List */}
//                 <div className="w-[25%] bg-white flex flex-col relative min-h-screen">
//                     {/* Header */}
//                     <div>
//                         <div className="flex items-center gap-4 p-4 chat-header">
//                             <Link to='/agents'><FaArrowLeft className="text-gray-700 cursor-pointer text-lg" /></Link>
//                             <div className="flex items-center gap-3 flex-1">
//                                 <div className="avatar flex items-center justify-center">
//                                     <FaUser className="text-white text-2xl" />
//                                 </div>
//                                 <div className="flex flex-col justify-center">
//                                     <span className="font-semibold text-gray-800 text-[16px] leading-4">
//                                         Business Name
//                                     </span>
//                                     <span className="text-xs text-[#7A91B7] pt-[2px]">All</span>
//                                 </div>
//                             </div>
//                             <div className="relative">
//                                 <FaEllipsisV
//                                     className="text-[#3f7fca] cursor-pointer text-lg "
//                                     onClick={toggleMenu}
//                                 />
//                                 {showMenu && (
//                                     <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg z-50">
//                                         <button
//                                             onClick={() => { setOpen(true); toggleMenu(); }}
//                                             className="flex items-center gap-2 px-4 py-2 w-full text-gray-700 hover:bg-gray-100 cursor-pointer">
//                                             <span className="text-[#14C19A] text-lg flex items-center">
//                                                 <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//                                                     <path d="M10 2V13" stroke="#14C19A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <path d="M6.5 9.5L10 13L13.5 9.5" stroke="#14C19A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//                                                     <rect x="4" y="16" width="12" height="2" rx="1" fill="#14C19A" />
//                                                 </svg>
//                                             </span>
//                                             <span className="text-[14px] font-medium">Export Conversation</span>
//                                         </button>
//                                         <Link to='/Admin/DownloadReport'>
//                                             <button className="flex items-center gap-2 px-4 py-2 w-full text-gray-700 hover:bg-gray-100 cursor-pointer">
//                                                 <span className="text-[#14C19A] text-lg flex items-center">
//                                                     <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//                                                         <ellipse cx="10" cy="10" rx="7" ry="5" stroke="#14C19A" strokeWidth="1.6" />
//                                                         <circle cx="10" cy="10" r="2.2" fill="#E7F9F4" stroke="#14C19A" strokeWidth="1.3" />
//                                                     </svg>
//                                                 </span>
//                                                 <span className="text-[14px] font-medium">Active Exports</span>
//                                             </button>
//                                         </Link>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                         {/* Filter/Search */}
//                         <div className="flex gap-2 items-center p-4 pb-2 border-b-0 filter-section">
//                             <div className="relative" style={{ width: "120px", minWidth: "80px" }}>
//                                 <select
//                                     className="form-select w-full pl-3  pr-4 py-[7px] rounded-xl border border-[#E3EBF6] bg-white text-[15px] font-semibold transition-colors duration-100 focus:ring-2 focus:ring-[#6a5af9] focus:border-[#6a5af9] text-[#6a5af9] cursor-pointer shadow-none"
//                                 >
//                                     <option style={{ color: "#6a5af9", background: "#fff" }}>All ({filteredChats.length})</option>
//                                     <option>UnRead (0)</option>
//                                     <option>Assigned (0)</option>
//                                     <option>UnAssigned (0)</option>
//                                     <option>Replied (0)</option>
//                                     <option>Pending (0)</option>
//                                     <option>Solved (0)</option>
//                                     <option>Open (0)</option>
//                                     <option>Block (0)</option>
//                                     <option>Favourite (0)</option>
//                                 </select>
//                             </div>
//                             <input
//                                 type="text"
//                                 placeholder="Search by number"
//                                 className="custom-select bg-white border border-[#E3EBF6] rounded-xl px-4 py-[7px] text-[15px] font-normal text-[#7A91B7] placeholder:text-[#7A91B7] outline-none min-w-[100px] focus:border-[#6a5af9] transition-colors duration-100"
//                                 style={{ boxShadow: "none" }}
//                                 value={search}
//                                 onChange={e => setSearch(e.target.value)}
//                             />
//                         </div>
//                     </div>
//                     {/* WhatsApp Contact List */}
//                     <div className="w-[100%] h-[500px] overflow-scroll bg-transparent px-2 py-2">
//                         {filteredChats.length === 0 ? (
//                             <div className="flex items-center justify-center h-full text-[#7A91B7] text-base">
//                                 No chats found
//                             </div>
//                         ) : (
//                             filteredChats
//                                 .filter(chat => chat.from_number != null)
//                                 .map((chat, index) => (
                       
//                                 <div
//                                     onClick={() => findUser(chat.from_number)}
//                                     key={chat.from_number}
//                                     className="flex items-center justify-between p-3 mb-2 bg-white rounded-lg shadow-sm hover:bg-gray-50 cursor-pointer"
//                                 >
//                                     <div className="flex items-center gap-3">
//                                         <div className="relative">
//                                             <div
//                                                 className={`w-12 h-12 flex items-center justify-center text-black font-bold rounded-xl uppercase ${colors[index % colors.length]}`}>
//                                                 {String(chat.from_number).slice(-2)}
//                                             </div>
//                                             <div className="absolute bottom-0 right-0 bg-white border rounded-full p-[2px] shadow">
//                                                 <FaUser className="text-black text-[10px]" />
//                                             </div>
//                                         </div>
//                                         <div>
//                                             <h4 className="font-semibold text-sm uppercase">{chat.from_number}</h4>
//                                             <p className="text-gray-500 text-sm truncate w-[160px]">{chat.lastMessage}</p>
//                                         </div>
//                                     </div>
//                                     <div className="text-xs text-gray-400 whitespace-nowrap">
//                                         {timeString(chat.lastTime)}
//                                     </div>
//                                     {/* Go to Live WhatsApp Chat button */}
//                                     <button
//                                         className="ml-2 text-xs text-blue-500 border border-blue-400 px-2 rounded hover:bg-blue-100 hidden"
//                                         onClick={e => { e.stopPropagation(); startLiveChat(chat); }}
//                                     >Live Chat</button>
//                                 </div>
//                             ))
//                         )}
//                     </div>
//                     <div className="pagination-footer text-sm p-3 border-t text-center ">
//                         {filteredChats.length > 0
//                             ? `1 - ${filteredChats.length} of ${filteredChats.length}`
//                             : "0 - 0 of 0"}
//                     </div>
//                 </div>

//                 {/* Main content: show Archive or LIVE chat */}
//                 <div
//                     onClick={() => setShowMenu(false)}
//                     className="w-[75%] h-[100%] flex items-center justify-center relative"
//                 >
//                     {liveActive && liveUser ? (
//                         // --- LIVE CHAT STRUCTURE (Enable with API) ---
//                         <div className="w-full h-full flex flex-col bg-white shadow px-6 py-4 rounded-lg relative">
//                             <div className="flex items-center mb-2">
//                                 <button className="mr-2 text-xs text-gray-400" onClick={closeLiveChat}>
//                                     &larr; Back
//                                 </button>
//                                 <h3 className="font-bold text-lg text-[#27446b]">
//                                     Live WhatsApp Chat: {liveUser.from_number}
//                                 </h3>
//                             </div>
//                             <div className="flex-1 overflow-y-auto py-2">
//                                 {liveMessages.length === 0 && (
//                                     <p className="text-gray-400 text-sm text-center mt-6">No live messages yet</p>
//                                 )}
//                                 {liveMessages.map((msg, idx) =>
//                                     <div
//                                         key={idx}
//                                         className={`my-2 flex ${msg.fromMe ? 'justify-end' : 'justify-start'}`}
//                                     >
//                                         <div className={`px-3 py-2 rounded-lg max-w-[60%] ${msg.fromMe ? 'bg-[#dcf8c6]' : 'bg-gray-100'} text-sm`}>
//                                             {msg.content}
//                                             <span className="block text-xs mt-1 text-gray-400">{timeString(msg.sentAt || msg.createdAt)}</span>
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                             <div className="flex items-center mt-auto pt-2">
//                                 <input
//                                     value={liveInput}
//                                     onChange={e => setLiveInput(e.target.value)}
//                                     type="text"
//                                     placeholder="Type a message..."
//                                     disabled={liveLoading}
//                                     className="flex-1 border border-gray-200 rounded-lg px-3 py-2 mr-2 focus:outline-none"
//                                 />
//                                 <button
//                                     onClick={sendLiveMessage}
//                                     disabled={liveLoading || !liveInput.trim()}
//                                     className="px-3 py-2 bg-[#37715d] text-white rounded font-semibold"
//                                 >Send</button>
//                             </div>
//                         </div>
//                     ) : selectedUser ? (
//                         <Whatapplivechat
//                             selectedUser={selectedUser}
//                             sendMessage={() => {}} // Disabled in archive mode
//                             currentPhoneNumberId={phoneNumberId}
//                         />
//                     ) : (
//                         <div className='w-[100%] flex justify-center items-center min-h-screen'>
//                             <img
//                                 src={bgimage}
//                                 alt="illustration"
//                                 className="w-[400px]"
//                             />
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Export Modal */}
//             <ExportConversationsmodal isOpen={Open} onClose={() => setOpen(false)} heading={'Export Conversations'} >
//                 <div className='w-[100%] border-y border-[#e3e9ef] my-4 pb-6'>
//                     <div>
//                         <label className='text-[14px] font-bold' htmlFor="">Date range:</label>
//                         <select
//                             className='p-2 border-[#e3e9ef] border-[1px] w-[100%] rounded-lg outline-none'
//                             value={Daterange}
//                             onChange={e => {
//                                 const value = e.target.value;
//                                 setDaterange(value);
//                                 setShowPicker(value === "custom");
//                             }}
//                         >
//                             <option value="7">Past 7 days</option>
//                             <option value="30">Past 30 days</option>
//                             <option value="90">Past 90 days</option>
//                             <option value="thisWeek">This Week</option>
//                             <option value="lastWeek">Previous Week</option>
//                             <option value="thisMonth">This Month</option>
//                             <option value="lastMonth">Previous Month</option>
//                             <option value="custom">Custom range</option>
//                         </select>
//                     </div>
//                     <div className='flex mt-3'>
//                         <input
//                             readOnly
//                             onClick={() => setShowPicker(!showPicker)}
//                             value={`${state[0].startDate.toLocaleDateString()} - ${state[0].endDate.toLocaleDateString()}`}
//                             className="border border-[#e3e9ef] rounded-lg p-2 text-sm w-full outline-none cursor-pointer"
//                         />
//                         {showPicker && (
//                             <div className="absolute z-50 mt-2">
//                                 <DateRange
//                                     editableDateInputs={true}
//                                     onChange={item => {
//                                         setState([item.selection]);
//                                         setShowPicker(false);
//                                     }}
//                                     moveRangeOnFirstSelection={false}
//                                     ranges={state}
//                                 />
//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 <div className='w-[100%] flex items-center justify-end gap-2'>
//                     <button
//                         onClick={() => setOpen(false)}
//                         className='hover:bg-[#d3dde6] bg-[#edf1f5] text-[#434a57] hover:text-[#000] p-2 rounded-md text-[14px] font-bold flex items-center'>
//                         Cancel
//                     </button>
//                     <button className='bg-[#37715d] border-[#37715d] text-white p-2 rounded-md text-[14px] font-bold'>
//                         Initiate Export
//                     </button>
//                 </div>
//             </ExportConversationsmodal>
//         </>
//     );
// };

// export default UserChatBox;
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './UserChatBox.css';
import { FaArrowLeft, FaEllipsisV, FaUser } from 'react-icons/fa';
import { FaUserPlus, FaUserMinus, FaChevronDown, FaCheck } from 'react-icons/fa6';
import { DateRange } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import bgimage from '../images/image-removebg-preview.png';
import ExportConversationsmodal from './Export ConversationsModal';
import WhatappchatforArchive from './whatappchatforArchive';
import Whatapplivechat from './whatapplivechat';

// ─── JWT helpers ──────────────────────────────────────────────────────────────

function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdAndToken() {
    if (typeof window !== 'undefined') {
        if (typeof window.locatorgarsotrga === 'function') {
            const rawToken = window.locatorgarsotrga("token");
            if (rawToken) {
                const decoded = decodeToken(rawToken);
                return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
            }
        }
        const localToken = localStorage.getItem('token');
        if (localToken) {
            const decoded = decodeToken(localToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: localToken };
        }
    }
    return { userId: null, token: null };
}

// ─── Assign Agent Dropdown ────────────────────────────────────────────────────

function AssignAgentPanel({ agents, currentAssignment, onAssign, onUnassign, assigning, phoneNumberId, customerNumber }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function handleClick(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, []);

    const isAssigned = currentAssignment?.status === 'assigned' && currentAssignment?.agent_id;

    return (
        <div className="relative" ref={ref}>
            {/* Trigger button */}
            <button
                onClick={() => setOpen(o => !o)}
                disabled={assigning}
                className={`flex items-center gap-2 px-3 py-1.5 rounded-xl text-[13px] font-semibold border transition-all duration-200
                    ${isAssigned
                        ? 'bg-[#e8f8f2] border-[#16D39A] text-[#37715d] hover:bg-[#d0f0e4]'
                        : 'bg-[#f0f4ff] border-[#6a5af9] text-[#6a5af9] hover:bg-[#e4e0ff]'
                    } ${assigning ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
            >
                {assigning ? (
                    <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />
                ) : isAssigned ? (
                    <FaCheck className="text-[11px]" />
                ) : (
                    <FaUserPlus className="text-[13px]" />
                )}
                <span className="max-w-[110px] truncate">
                    {isAssigned ? currentAssignment.agent_name || 'Assigned' : 'Assign Agent'}
                </span>
                <FaChevronDown className={`text-[10px] transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
            </button>

            {/* Dropdown */}
            {open && (
                <div className="absolute right-0 top-full mt-2 w-[220px] bg-white rounded-2xl shadow-[0_8px_30px_rgba(0,0,0,0.12)] border border-[#f0f4ff] z-[100] overflow-hidden animate-fadeIn">
                    {/* Header */}
                    <div className="px-4 py-3 bg-[#f8faff] border-b border-[#eef1f8]">
                        <p className="text-[11px] uppercase font-bold tracking-wider text-[#94a3b8]">Assign to Agent</p>
                        {isAssigned && (
                            <p className="text-[12px] text-[#37715d] font-semibold mt-0.5 truncate">
                                ✓ {currentAssignment.agent_name}
                            </p>
                        )}
                    </div>

                    {/* Agent list */}
                    <div className="max-h-[200px] overflow-y-auto py-1">
                        {agents.length === 0 ? (
                            <div className="px-4 py-3 text-[12px] text-[#94a3b8] text-center">
                                No agents available
                            </div>
                        ) : (
                            agents.map(agent => {
                                const isThis = currentAssignment?.agent_id === agent.id && isAssigned;
                                return (
                                    <button
                                        key={agent.id}
                                        onClick={() => { onAssign(agent); setOpen(false); }}
                                        className={`w-full flex items-center gap-3 px-4 py-2.5 text-left transition-colors duration-100
                                            ${isThis ? 'bg-[#e8f8f2]' : 'hover:bg-[#f8faff]'}`}
                                    >
                                        <div className={`w-8 h-8 rounded-xl flex items-center justify-center text-[11px] font-bold uppercase
                                            ${isThis ? 'bg-[#16D39A] text-white' : 'bg-[#e8edf8] text-[#6a5af9]'}`}>
                                            {agent.name?.slice(0, 2) || 'AG'}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <p className={`text-[13px] font-semibold truncate ${isThis ? 'text-[#37715d]' : 'text-[#27446b]'}`}>
                                                {agent.name}
                                            </p>
                                            <p className="text-[11px] text-[#94a3b8] truncate">{agent.email}</p>
                                        </div>
                                        {isThis && <FaCheck className="text-[#16D39A] text-[11px] flex-shrink-0" />}
                                    </button>
                                );
                            })
                        )}
                    </div>

                    {/* Unassign footer */}
                    {isAssigned && (
                        <div className="border-t border-[#eef1f8] p-2">
                            <button
                                onClick={() => { onUnassign(); setOpen(false); }}
                                className="w-full flex items-center gap-2 px-3 py-2 rounded-xl text-[12px] font-semibold text-red-400 hover:bg-red-50 transition-colors duration-100"
                            >
                                <FaUserMinus className="text-[13px]" />
                                Unassign Agent
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

// ─── Assignment Badge (for contact list) ─────────────────────────────────────

function AssignmentBadge({ agentName }) {
    if (!agentName) return null;
    return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#e8f8f2] text-[#37715d] text-[10px] font-semibold border border-[#c3edd9] max-w-[90px] truncate">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16D39A] flex-shrink-0" />
            <span className="truncate">{agentName}</span>
        </span>
    );
}

// ─── Main UserChatBox ─────────────────────────────────────────────────────────

const UserChatBox = () => {
    // Drawer controls
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef(null);
    const toggleMenu = () => setShowMenu(prev => !prev);

    // Export Modal
    const [Open, setOpen] = useState(false);
    const [showPicker, setShowPicker] = useState(false);
    const [state, setState] = useState([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
    const [Daterange, setDaterange] = useState('');

    // User & phone
    const { userId, token } = getUserIdAndToken();
    const [phoneNumberId, setPhoneNumberId] = useState('');

    useEffect(() => {
        if (userId && token) {
            fetch(`https://wa-api.globebot.io/auth/user/whatsapp-phone-numbers/${userId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(r => r.json())
                .then(data => {
                    if (Array.isArray(data) && data[0]?.phone_number_id) {
                        setPhoneNumberId(data[0].phone_number_id);
                    }
                })
                .catch(console.error);
        }
    }, [userId, token]);

    // Archive messages
    const [messages, setMessages] = useState([]);
    const [search, setSearch] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        if (phoneNumberId && token) {
            fetch(`https://wa-api.globebot.io/auth/messages/?phone_number_id=${phoneNumberId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
                .then(res => res.json())
                .then(data => setMessages(Array.isArray(data) ? data : []))
                .catch(console.error);
        }
    }, [phoneNumberId, token]);

    // ── ASSIGN AGENT STATE ────────────────────────────────────────────────────
    const [agents, setAgents] = useState([]);
    const [assignmentMap, setAssignmentMap] = useState({}); // { customer_number -> assignment }
    const [currentAssignment, setCurrentAssignment] = useState(null);
    const [assigning, setAssigning] = useState(false);

    // Load agents list (once we know userId)
    useEffect(() => {
        if (!userId || !token) return;
        fetch(`https://wa-api.globebot.io/auth/agents/by-account?user_id=${userId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setAgents(data.data); })
            .catch(console.error);
    }, [userId, token]);

    // Load bulk assignment map for sidebar badges (once we have phoneNumberId)
    useEffect(() => {
        if (!phoneNumberId || !token) return;
        fetch(`https://wa-api.globebot.io/auth/chat-assignments/bulk?phone_number_id=${phoneNumberId}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setAssignmentMap(data.data); })
            .catch(console.error);
    }, [phoneNumberId, token]);

    // Load assignment for selected user
    useEffect(() => {
        if (!selectedUser || !phoneNumberId || !token) { setCurrentAssignment(null); return; }
        fetch(`https://wa-api.globebot.io/auth/chat-assignment?phone_number_id=${phoneNumberId}&customer_number=${selectedUser.from_number}`, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(r => r.json())
            .then(data => { if (data.success) setCurrentAssignment(data.data); })
            .catch(console.error);
    }, [selectedUser, phoneNumberId, token]);

    // Assign handler
    const handleAssign = useCallback(async (agent) => {
        if (!selectedUser || !phoneNumberId) return;
        setAssigning(true);
        try {
            const res = await fetch('https://wa-api.globebot.io/auth/assign-chat', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phone_number_id: phoneNumberId,
                    customer_number: selectedUser.from_number,
                    agent_id: agent.id,
                    assigned_by: userId,
                })
            });
            const data = await res.json();
            if (data.success) {
                const newAssignment = {
                    agent_id: agent.id,
                    agent_name: agent.name,
                    status: 'assigned',
                    assigned_at: new Date().toISOString(),
                };
                setCurrentAssignment(newAssignment);
                setAssignmentMap(prev => ({
                    ...prev,
                    [selectedUser.from_number]: { ...newAssignment, customer_number: selectedUser.from_number }
                }));
            }
        } catch (err) {
            console.error('Assign error:', err);
        } finally {
            setAssigning(false);
        }
    }, [selectedUser, phoneNumberId, token, userId]);

    // Unassign handler
    const handleUnassign = useCallback(async () => {
        if (!selectedUser || !phoneNumberId) return;
        setAssigning(true);
        try {
            const res = await fetch('https://wa-api.globebot.io/auth/unassign-chat', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    phone_number_id: phoneNumberId,
                    customer_number: selectedUser.from_number,
                })
            });
            const data = await res.json();
            if (data.success) {
                setCurrentAssignment(null);
                setAssignmentMap(prev => {
                    const next = { ...prev };
                    delete next[selectedUser.from_number];
                    return next;
                });
            }
        } catch (err) {
            console.error('Unassign error:', err);
        } finally {
            setAssigning(false);
        }
    }, [selectedUser, phoneNumberId, token]);

    // ── Chat grouping ─────────────────────────────────────────────────────────
    function groupConversations(msgs) {
        // Only include chats/messages with a last message within the last 24 hours
        const grouped = {};
        const now = Date.now();
        msgs.forEach(msg => {
            const key = msg.from_number;
            const profileName = msg.profileName;
            if (!grouped[key]) {
                grouped[key] = { from_number: key, profileName: profileName, phone_number_id: msg.phone_number_id, messages: [], lastMessage: '', lastTime: '', unread: 0 };
            }
            grouped[key].messages.push(msg);
            if (!grouped[key].lastTime || new Date(msg.created_at) > new Date(grouped[key].lastTime)) {
                grouped[key].lastMessage = msg.content;
                grouped[key].lastTime = msg.created_at;
            }
            if (msg.status === 'received') grouped[key].unread += 1;
        });

        // Filter grouped chats to only those whose lastTime is within the past 24 hours
        return Object.values(grouped).filter(chat => {
            if (!chat.lastTime) return false;
            const lastTimeMs = new Date(chat.lastTime).getTime();
            return (now - lastTimeMs) <= 24 * 60 * 60 * 1000;
        });
    }

    const groupedChats = groupConversations(messages);
    const filteredChats = groupedChats.filter(chat =>
        (chat.from_number || "").toLowerCase().includes(search.toLowerCase())
    );

    function findUser(number) {
        const userChat = groupedChats.find(item => item.from_number === number);
        setSelectedUser(userChat || null);
    }

    // Live chat state
    const [liveActive, setLiveActive] = useState(false);
    const [liveUser, setLiveUser] = useState(null);
    const [liveMessages, setLiveMessages] = useState([]);
    const [liveInput, setLiveInput] = useState('');
    const [liveLoading, setLiveLoading] = useState(false);

    const startLiveChat = (user) => { setLiveActive(true); setLiveUser(user); setLiveMessages([]); };
    const sendLiveMessage = async () => {
        setLiveLoading(true);
        setLiveMessages(prev => [...prev, { fromMe: true, content: liveInput, sentAt: new Date().toISOString() }]);
        setLiveInput('');
        setLiveLoading(false);
    };
    const closeLiveChat = () => { setLiveActive(false); setLiveUser(null); setLiveMessages([]); setLiveInput(''); };

    const colors = ["bg-red-200", "bg-green-200", "bg-blue-200", "bg-yellow-200", "bg-purple-200", "bg-pink-200", "bg-indigo-200"];

    function timeString(iso) {
        if (!iso) return "";
        return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }

    return (
        <>
            <div className="flex min-h-screen bg-gray-100 pt-[100px] sm:pt-[50px]">
                {/* ── Sidebar ───────────────────────────────────────────────── */}
                <div className="w-[25%] bg-white flex flex-col relative min-h-screen">
                    {/* Header */}
                    <div>
                        <div className="flex items-center gap-4 p-4 chat-header">
                            <Link to='/agents'><FaArrowLeft className="text-gray-700 cursor-pointer text-lg" /></Link>
                            <div className="flex items-center gap-3 flex-1">
                                <div className="avatar flex items-center justify-center">
                                    <FaUser className="text-white text-2xl" />
                                </div>
                                <div className="flex flex-col justify-center">
                                    <span className="font-semibold text-gray-800 text-[16px] leading-4">Business Name</span>
                                    <span className="text-xs text-[#7A91B7] pt-[2px]">All</span>
                                </div>
                            </div>
                            <div className="relative">
                                <FaEllipsisV className="text-[#3f7fca] cursor-pointer text-lg" onClick={toggleMenu} />
                                {showMenu && (
                                    <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg z-50">
                                        <button
                                            onClick={() => { setOpen(true); toggleMenu(); }}
                                            className="flex items-center gap-2 px-4 py-2 w-full text-gray-700 hover:bg-gray-100 cursor-pointer">
                                            <span className="text-[#14C19A] text-lg flex items-center">
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M10 2V13" stroke="#14C19A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M6.5 9.5L10 13L13.5 9.5" stroke="#14C19A" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                                    <rect x="4" y="16" width="12" height="2" rx="1" fill="#14C19A" />
                                                </svg>
                                            </span>
                                            <span className="text-[14px] font-medium">Export Conversation</span>
                                        </button>
                                        <Link to='/Admin/DownloadReport'>
                                            <button className="flex items-center gap-2 px-4 py-2 w-full text-gray-700 hover:bg-gray-100 cursor-pointer">
                                                <span className="text-[#14C19A] text-lg flex items-center">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <ellipse cx="10" cy="10" rx="7" ry="5" stroke="#14C19A" strokeWidth="1.6" />
                                                        <circle cx="10" cy="10" r="2.2" fill="#E7F9F4" stroke="#14C19A" strokeWidth="1.3" />
                                                    </svg>
                                                </span>
                                                <span className="text-[14px] font-medium">Active Exports</span>
                                            </button>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Filter/Search */}
                        <div className="flex gap-2 items-center p-4 pb-2 border-b-0 filter-section">
                            <div className="relative" style={{ width: "120px", minWidth: "80px" }}>
                                <select className="form-select w-full pl-3 pr-4 py-[7px] rounded-xl border border-[#E3EBF6] bg-white text-[15px] font-semibold transition-colors duration-100 focus:ring-2 focus:ring-[#6a5af9] focus:border-[#6a5af9] text-[#6a5af9] cursor-pointer shadow-none">
                                    <option style={{ color: "#6a5af9", background: "#fff" }}>All ({filteredChats.length})</option>
                                    <option>UnRead (0)</option>
                                    <option>Assigned ({Object.values(assignmentMap).filter((a) => a?.status === 'assigned').length})</option>
                                    <option>UnAssigned (0)</option>
                                    <option>Replied (0)</option>
                                    <option>Pending (0)</option>
                                    <option>Solved (0)</option>
                                    <option>Open (0)</option>
                                    <option>Block (0)</option>
                                    <option>Favourite (0)</option>
                                </select>
                            </div>
                            <input
                                type="text"
                                placeholder="Search by number"
                                className="custom-select bg-white border border-[#E3EBF6] rounded-xl px-4 py-[7px] text-[15px] font-normal text-[#7A91B7] placeholder:text-[#7A91B7] outline-none min-w-[100px] focus:border-[#6a5af9] transition-colors duration-100"
                                style={{ boxShadow: "none" }}
                                value={search}
                                onChange={e => setSearch(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Contact list */}
                    <div className="w-full h-[500px] overflow-scroll bg-transparent px-2 py-2">
                        {filteredChats.length === 0 ? (
                            <div className="flex items-center justify-center h-full text-[#7A91B7] text-base">No chats found</div>
                        ) : (
                            filteredChats
                                .filter(chat => chat.from_number != null)
                                .map((chat, index) => {
                                    const assignment = assignmentMap[chat.from_number];
                                    const isSelected = selectedUser?.from_number === chat.from_number;
                                    return (
                                        <div
                                            onClick={() => findUser(chat.from_number)}
                                            key={chat.from_number}
                                            className={`flex items-center justify-between p-3 mb-2 rounded-lg shadow-sm cursor-pointer transition-all duration-150
                                                ${isSelected ? 'bg-[#f0fdf8] border border-[#c3edd9]' : 'bg-white hover:bg-gray-50'}`}
                                        >
                                            <div className="flex items-center gap-3 min-w-0 flex-1">
                                                <div className="relative flex-shrink-0">
                                                    <div className={`w-12 h-12 flex items-center justify-center text-black font-bold rounded-xl uppercase ${colors[index % colors.length]}`}>
                                                        {String(chat.profileName || chat.name || chat.from_number).slice(-2)}
                                                   
                                                    </div>
                                                    {/* Online dot if assigned */}
                                                    {assignment?.status === 'assigned' && (
                                                        <span className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-[#16D39A] border-2 border-white rounded-full" />
                                                    )}
                                                    <div className="absolute bottom-0 right-0 bg-white border rounded-full p-[2px] shadow">
                                                        <FaUser className="text-black text-[10px]" />
                                                    </div>
                                                </div>
                                                <div className="min-w-0 flex-1">
                                                    <div className="flex items-center gap-2 flex-wrap">
                                                        <h4 className="font-semibold text-sm uppercase">{String(chat.profileName || chat.name || chat.from_number)}</h4>
                                                    </div>
                                                    {/* Assignment badge */}
                                                    {assignment?.status === 'assigned' && (
                                                        <AssignmentBadge agentName={assignment.agent_name} />
                                                    )}
                                                    <p className="text-gray-500 text-xs truncate w-[130px] mt-0.5">{chat.lastMessage}</p>
                                                </div>
                                            </div>
                                            <div className="text-xs text-gray-400 whitespace-nowrap ml-2 flex-shrink-0">
                                                {timeString(chat.lastTime)}
                                            </div>
                                        </div>
                                    );
                                })
                        )}
                    </div>

                    <div className="pagination-footer text-sm p-3 border-t text-center">
                        {filteredChats.length > 0 ? `1 - ${filteredChats.length} of ${filteredChats.length}` : "0 - 0 of 0"}
                    </div>
                </div>

                {/* ── Main content ─────────────────────────────────────────── */}
                <div onClick={() => setShowMenu(false)} className="w-[75%] h-full flex flex-col relative">

                    {/* ── Assign Agent header bar (only when a chat is selected) ── */}
                    {selectedUser && !liveActive && (
                        <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-[#eef1f8] shadow-sm z-10">
                            <div className="flex items-center gap-3">
                                <div className={`w-9 h-9 rounded-xl flex items-center justify-center text-[12px] font-bold uppercase ${colors[0]}`}>
                                    {String(selectedUser.profileName || selectedUser.from_number).slice(-2)}
                                </div>
                                <div>
                                    <p className="font-semibold text-[14px] text-[#27446b]">{String(selectedUser.profileName || selectedUser.from_number) }</p>
                                    <p className="font-semibold text-[11px] text-[#94a3b8]">{selectedUser.from_number}</p>
                                    <p className="text-[11px] text-[#94a3b8] hidden">
                                        {currentAssignment?.status === 'assigned'
                                            ? `Assigned to ${currentAssignment.agent_name}`
                                            : 'Unassigned'
                                        }
                                    </p>
                                </div>
                            </div>

                            <AssignAgentPanel
                                agents={agents}
                                currentAssignment={currentAssignment}
                                onAssign={handleAssign}
                                onUnassign={handleUnassign}
                                assigning={assigning}
                                phoneNumberId={phoneNumberId}
                                customerNumber={selectedUser.from_number}
                            />
                        </div>
                    )}

                    {/* ── Chat area ─────────────────────────────────────────── */}
                    <div className="flex-1 flex items-center justify-center">
                        {liveActive && liveUser ? (
                            <div className="w-full h-full flex flex-col bg-white shadow px-6 py-4 rounded-lg relative">
                                <div className="flex items-center mb-2">
                                    <button className="mr-2 text-xs text-gray-400" onClick={closeLiveChat}>&larr; Back</button>
                                    <h3 className="font-bold text-lg text-[#27446b]">Live Chat: {liveUser.from_number}</h3>
                                </div>
                                <div className="flex-1 overflow-y-auto py-2">
                                    {liveMessages.length === 0 && <p className="text-gray-400 text-sm text-center mt-6">No live messages yet</p>}
                                    {liveMessages.map((msg, idx) => (
                                        <div key={idx} className={`my-2 flex ${msg.fromMe ? 'justify-end' : 'justify-start'}`}>
                                            <div className={`px-3 py-2 rounded-lg max-w-[60%] ${msg.fromMe ? 'bg-[#dcf8c6]' : 'bg-gray-100'} text-sm`}>
                                                {msg.content}
                                                <span className="block text-xs mt-1 text-gray-400">{timeString(msg.sentAt || msg.createdAt)}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="flex items-center mt-auto pt-2">
                                    <input value={liveInput} onChange={e => setLiveInput(e.target.value)} type="text" placeholder="Type a message..." disabled={liveLoading} className="flex-1 border border-gray-200 rounded-lg px-3 py-2 mr-2 focus:outline-none" />
                                    <button onClick={sendLiveMessage} disabled={liveLoading || !liveInput.trim()} className="px-3 py-2 bg-[#37715d] text-white rounded font-semibold">Send</button>
                                </div>
                            </div>
                        ) : selectedUser ? (
                            <div className="w-full h-full">
                                <Whatapplivechat
                                    selectedUser={selectedUser}
                                    sendMessage={() => {}}
                                    currentPhoneNumberId={phoneNumberId}
                                />
                            </div>
                        ) : (
                            <div className='w-full flex justify-center items-center min-h-screen'>
                                <img src={bgimage} alt="illustration" className="w-[400px]" />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Export Modal */}
            <ExportConversationsmodal isOpen={Open} onClose={() => setOpen(false)} heading={'Export Conversations'}>
                <div className='w-full border-y border-[#e3e9ef] my-4 pb-6'>
                    <div>
                        <label className='text-[14px] font-bold'>Date range:</label>
                        <select
                            className='p-2 border-[#e3e9ef] border-[1px] w-full rounded-lg outline-none'
                            value={Daterange}
                            onChange={e => { const v = e.target.value; setDaterange(v); setShowPicker(v === "custom"); }}
                        >
                            <option value="7">Past 7 days</option>
                            <option value="30">Past 30 days</option>
                            <option value="90">Past 90 days</option>
                            <option value="thisWeek">This Week</option>
                            <option value="lastWeek">Previous Week</option>
                            <option value="thisMonth">This Month</option>
                            <option value="lastMonth">Previous Month</option>
                            <option value="custom">Custom range</option>
                        </select>
                    </div>
                    <div className='flex mt-3'>
                        <input
                            readOnly
                            onClick={() => setShowPicker(!showPicker)}
                            value={`${state[0].startDate.toLocaleDateString()} - ${state[0].endDate.toLocaleDateString()}`}
                            className="border border-[#e3e9ef] rounded-lg p-2 text-sm w-full outline-none cursor-pointer"
                        />
                        {showPicker && (
                            <div className="absolute z-50 mt-2">
                                <DateRange editableDateInputs={true} onChange={item => { setState([item.selection]); setShowPicker(false); }} moveRangeOnFirstSelection={false} ranges={state} />
                            </div>
                        )}
                    </div>
                </div>
                <div className='w-full flex items-center justify-end gap-2'>
                    <button onClick={() => setOpen(false)} className='hover:bg-[#d3dde6] bg-[#edf1f5] text-[#434a57] hover:text-[#000] p-2 rounded-md text-[14px] font-bold flex items-center'>Cancel</button>
                    <button className='bg-[#37715d] border-[#37715d] text-white p-2 rounded-md text-[14px] font-bold'>Initiate Export</button>
                </div>
            </ExportConversationsmodal>
        </>
    );
};

export default UserChatBox;